import { combineReducers } from 'redux';
import { reducer as auditReducer, storeKey as auditStoreKey } from './auditDuck';
import { reducer as connectivityReducer, storeKey as connectivityStoreKey } from './connectivityDuck';
import { reducer as existingUsersReducer, storeKey as existingUsersStoreKey } from './existingUsersDuck';
import { reducer as externalUsersReducer, storeKey as externalUsersStoreKey } from './externalUsersDuck';
import { reducer as organizationReducer, storeKey as organizationStoreKey } from './organizationDuck';
import {
  reducer as organizationSettingsReducer,
  storeKey as organizationSettingsStoreKey,
} from './organizationSettingsDuck';
import { reducer as organizationsReducer, storeKey as organizationsStoreKey } from './organizationsDuck';
import { reducer as organizationUsersReducer, storeKey as organizationUsersStoreKey } from './organizationUsersDuck';

export default combineReducers({
  [organizationsStoreKey]: organizationsReducer,
  [organizationStoreKey]: organizationReducer,
  [organizationUsersStoreKey]: organizationUsersReducer,
  [existingUsersStoreKey]: existingUsersReducer,
  [externalUsersStoreKey]: externalUsersReducer,
  [organizationSettingsStoreKey]: organizationSettingsReducer,
  [auditStoreKey]: auditReducer,
  [connectivityStoreKey]: connectivityReducer,
});
